import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter } from "react-router-dom"
import { MaterialUIControllerProvider } from "./components/context"
import { ToastProvider } from "@dalgu/react-toast"
import AppContainer from "./AppContainer"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <ToastProvider duration={2} zIndex={100}>
        <AppContainer />
      </ToastProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
